import { createContext } from 'react';

const DataConsumptionMetricContext = createContext();

export default DataConsumptionMetricContext;
